import React from 'react'

const ProductManagementFormatorSubcategory: React.FC = () => (
  <svg width="72" height="73" viewBox="0 0 72 73" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.538452" width="72" height="72" rx="14.5455" fill="url(#paint0_linear_4674_17893)" />
    <path
      d="M22.4756 30.5355C22.4756 30.6825 22.4756 30.8295 22.4756 30.9275C22.4756 36.2197 22.5246 41.5609 22.4756 46.8531C22.4756 48.6661 23.8966 50.0382 25.6607 50.0382C32.57 49.9892 39.4792 50.0382 46.3885 50.0382C48.2995 50.0382 49.5736 48.7641 49.5736 46.8531C49.5736 41.5609 49.5736 36.2197 49.5736 30.9275C49.5736 30.7805 49.5736 30.6825 49.5736 30.5355C40.4593 30.5355 31.4919 30.5355 22.4756 30.5355ZM41.9783 38.0327C41.9783 38.8658 41.2923 39.5028 40.5083 39.5028H31.4919C30.6589 39.5028 30.0219 38.8168 30.0219 38.0327C30.0219 37.1997 30.7079 36.5627 31.4919 36.5627H40.5083C41.2923 36.5627 41.9783 37.2487 41.9783 38.0327Z"
      fill="white"
    />
    <path
      d="M49.3286 29.0169H22.6716C21.7406 29.0169 20.9565 28.2329 20.9565 27.3019V24.7538C20.9565 23.8227 21.7406 23.0387 22.6716 23.0387H49.3286C50.2596 23.0387 51.0437 23.8227 51.0437 24.7538V27.3509C50.9947 28.2329 50.2596 29.0169 49.3286 29.0169Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4674_17893"
        x1="35.5325"
        y1="0.538455"
        x2="91.0286"
        y2="43.7385"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6600E8" />
        <stop offset="1" stopColor="#BD0044" />
      </linearGradient>
    </defs>
  </svg>
)

export default ProductManagementFormatorSubcategory
